import type { Router } from 'vue-router';

import { useAuth } from '@/composable/msal';

const auth = useAuth();

export const registerAuthGuard = (router: Router): void => {
  router.beforeEach(async (to) => {
    if (!to.meta.public) {
      await auth.protect();
    }

    return true;
  });
};
